import { FC } from 'react';
import { useTranslation, Trans } from 'next-i18next';
import {
  EXTERNAL_PATHS,
  GMB_SUPPORT_EMAIL,
  SUPPORT_URLS,
} from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import PitchPageFAQ from 'src/common/components/PitchPageFAQ';
import Typography from 'src/common/components/Typography';
import UniversalLink from 'src/common/components/UniversalLink';

const faqList0 = [0, 1, 2, 3, 4, 5];

const OwnerFAQ: FC = () => {
  const [t] = useTranslation('safety-page');

  return (
    <PitchPageLayout backgroundColor="ivory">
      <PitchPageFAQ
        additionalText={(
          <Trans
            t={t}
            i18nKey="faq--text"
            components={{
              helpCenter: (
                <UniversalLink
                  href={SUPPORT_URLS.HELP_CENTER}
                  openInNewTab
                />
              ),
              break: (
                <br />
              ),
            }}
          />
        )}
        faqs={[
          {
            question: t('owner-faq--question-0'),
            answer: (
              <>
                <Typography type="p" size="body-l">
                  {t('owner-faq--answer-0--p-0')}
                </Typography>
                <ol>
                  {faqList0.map((item) => (
                    <li key={item}>
                      <Typography type="p" size="body-l">
                        {t(`owner-faq--answer-0--list-0--listItem-${item}`)}
                      </Typography>
                    </li>
                  ))}
                </ol>
                <Typography type="p" size="body-l">
                  <Trans
                    t={t}
                    i18nKey="owner-faq--answer-0--p-1"
                    values={{ supportEmail: GMB_SUPPORT_EMAIL }}
                    components={{
                      emailLink: (
                        <UniversalLink
                          href={`mailto:${GMB_SUPPORT_EMAIL}`}
                          openInNewTab
                        />
                      ),
                    }}
                  />
                </Typography>
              </>
            ),
          },
          {
            question: t('owner-faq--question-1'),
            answer: (
              <>
                <Typography type="p" size="body-l">
                  {t('owner-faq--answer-1--p-0')}
                </Typography>
                <Typography type="p" size="body-l">
                  {t('owner-faq--answer-1--p-1')}
                </Typography>
                <Typography type="p" size="body-l">
                  {t('owner-faq--answer-1--p-2')}
                </Typography>
                <Typography type="p" size="body-l">
                  {t('owner-faq--answer-1--p-3')}
                </Typography>
                <Typography type="p" size="body-l">
                  <Trans
                    t={t}
                    i18nKey="owner-faq--answer-1--p-4"
                    components={{
                      courseLink: (
                        <UniversalLink
                          href={`${EXTERNAL_PATHS.JOURNAL}boating-safety/boater-education-courses-and-certifications/`}
                          openInNewTab
                        />
                      ),
                    }}
                  />
                </Typography>
              </>
            ),
          },
          {
            question: t('owner-faq--question-2'),
            answer: (
              <>
                <Typography type="p" size="body-l">
                  {t('owner-faq--answer-2--p-0')}
                </Typography>
                <Typography type="p" size="body-l">
                  <Trans
                    t={t}
                    i18nKey="owner-faq--answer-2--p-1"
                    components={{
                      securityAllowance: (
                        <UniversalLink
                          href={SUPPORT_URLS.WHAT_IS_THE_SECURITY_ALLOWANCE}
                          openInNewTab
                        />
                      ),
                    }}
                  />
                </Typography>
                <Typography type="p" size="body-l">
                  <Trans
                    t={t}
                    i18nKey="owner-faq--answer-2--p-2"
                    components={{
                      learnMore: (
                        <UniversalLink
                          href={SUPPORT_URLS.WHAT_TO_EXPECT_FROM_REPORTING_DAMAGES}
                          openInNewTab
                        />
                      ),
                    }}
                  />
                </Typography>
              </>
            ),
          },
        ]}
        title={t('owner-faq--title')}
      />
    </PitchPageLayout>
  );
};

export default OwnerFAQ;
